import {Observable} from 'rxjs';
import {ConfigurationService} from '../Configuration/configuration-service';
import {IPublisherInitializer} from './ipublisher-initializer';
import {ReadResult} from './data/read-result';

export enum DataType {
    GRID,
    GRIDS,  // list of GRID without content
    ROW,
    ROWS, // list of rows
    INTRADAY,
    HISTORICAL,
    FUND_HISTORICAL,
    DIVIDEND,
    CORRECTION,
    LIST_NEWS,
    NEWS,

    // METADATA
    META_LIST_GRIDS, // List of available GRIDS


    // WIDGET CONFIGURATION
    R_OUTCONF,      // Widget configuration (data.js format)
    R_WIDGET,
    R_WIDGET_PART,
    W_WIDGET,
    W_WIDGET_PART
}

export interface IPublisher {
    /**
     * Read content from remote service
     * @param publisherParameters Map af rewriteble parameter. This Map is returned calling getRewritableParameterMap().
     * @param SubscribeObjInfo specifi parameter for call
     * @param callerData generic object that can be used to pass data to publisher and received back in Result
     * @param dataType datatype requested
     */
    // tslint:disable-next-line:ban-types max-line-length
    read(publisherParameters: Map<string, string>, SubscribeObjInfo: string[], dataType: DataType, callerData: any): Observable<Object>;
    initialize(initializer: IPublisherInitializer, configuration: ConfigurationService);

    /**
     * Return a Map containing rewritable parameter.
     * All values are initializate whith initial values as configuration
     * This Map must be used in read method
     */
    getRewritableParameterMap(): Map<string, string>;
}
